var map = {
	"./Sonar-dark.svg": 3020,
	"./Sonar.svg": 3975,
	"./ada-dark.svg": 2231,
	"./ada.svg": 8846,
	"./analysis.png": 863,
	"./android-dark.svg": 6496,
	"./android.svg": 19,
	"./assembly.png": 9081,
	"./c++.svg": 6323,
	"./c.svg": 9009,
	"./c3.svg": 4336,
	"./carbon.png": 4422,
	"./circt.svg": 8289,
	"./clean.svg": 4445,
	"./cmake.svg": 5851,
	"./crystal-dark.svg": 1233,
	"./crystal.svg": 9644,
	"./cuda-dark.svg": 2448,
	"./cuda.svg": 4480,
	"./d.svg": 1630,
	"./dart.svg": 7469,
	"./dotnet.svg": 4892,
	"./elixir.svg": 5963,
	"./erlang.svg": 975,
	"./fortran.svg": 6004,
	"./fsharp.svg": 6856,
	"./gimple.svg": 6076,
	"./go.svg": 6288,
	"./haskell.png": 1097,
	"./hlsl.png": 4228,
	"./hook-dark.png": 7883,
	"./hook.png": 9384,
	"./hylo.svg": 4060,
	"./ispc.png": 7078,
	"./java.svg": 8478,
	"./js.svg": 9019,
	"./julia.svg": 7545,
	"./kotlin.svg": 2033,
	"./llvm.png": 5206,
	"./mlir.svg": 1796,
	"./nim.svg": 8826,
	"./ocaml.svg": 8290,
	"./opencl-dark.svg": 3300,
	"./opencl.svg": 4751,
	"./pascal-dark.svg": 3067,
	"./pascal.svg": 6442,
	"./pony.svg": 5198,
	"./python.svg": 964,
	"./racket.svg": 7640,
	"./ruby.svg": 390,
	"./rust-dark.svg": 7565,
	"./rust.svg": 7648,
	"./scala.png": 2915,
	"./snowball.svg": 9836,
	"./solidity.svg": 4633,
	"./spice.png": 3955,
	"./swift.svg": 3559,
	"./toit.svg": 1798,
	"./ts.svg": 7537,
	"./v.svg": 2572,
	"./vala.svg": 2656,
	"./zig.svg": 9212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66;